import * as React from 'react';
import ProgressBar from './ProgressBar';
import { jsx as _jsx } from "react/jsx-runtime";

const ProgressWrap = props => /*#__PURE__*/_jsx("div", {
  className: "progress-wrap",
  children: props.children
});

ProgressWrap.displayName = 'ProgressWrap';
export default Object.assign(ProgressWrap, {
  Items: ProgressBar
});